var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-info-thumbnail',{attrs:{"icon":['fas', 'map-marker-alt'],"text-lines":[
      { type: 'title', value: 'Suite 500' },
      { type: 'title', value: '10405 Jasper Avenue' },
      { type: 'title', value: 'Edmonton, Alberta' },
      { type: 'title', value: 'T5J 3N4' } ]}}),_c('app-info-thumbnail',{attrs:{"icon":['fas', 'phone-alt'],"text-lines":[
      { type: 'title', value: 'Phone: 780.413.0099' },
      { type: 'title', value: 'Toll Free Within Alberta - Phone: 1.888.413.0099' },
      { type: 'title', value: 'Fax: 780.424.5134' } ]}}),_c('app-info-thumbnail',{attrs:{"icon":['fas', 'envelope'],"text-lines":[
      { type: 'title', value: 'General Inquiries' },
      { type: 'content-link', value: 'sccinfo@safetycodes.ab.ca' } ]}}),_c('app-info-thumbnail',{attrs:{"icon":['fas', 'desktop'],"text-lines":[
      { type: 'title', value: 'Alberta Safety Codes Authority' },
      { type: 'subtitle', value: 'Storage Tank Systems' },
      { type: 'content-link', value: 'ascatanks@safetycodes.ab.ca' },
      { type: 'empty' },
      { type: 'content-text', value: 'Phone: 780.413.0099 - #2 ASCA, #2 ASCA Storage Tanks' },
      { type: 'content-text', value: 'Toll Free: 1.888.413.0099 - - #2 ASCA, #2 ASCA Storage Tanks' },
      { type: 'empty' },
      { type: 'content-text', value: 'Business Hours: 8:00 a.m. - 4:30 p.m' } ]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }